import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Collapse, CardBody, Col, Container, Row } from "reactstrap";

// import AnimatePage from "../../components/AnimatePage";
import { about_feature_img, yt_pst_img } from "../../images";
import "../sass/about.scss";
import TextSlicer from "../../components/TextSlicer";
import MetaData from "../../components/MetaData";
import FAQAccordion from "../../components/FAQAccordion";
const description = `SoftoRithm Technologies is proud to provide a wide range of services regarding design, web development, app development, strategy, and digital marketing. Connect with us to bring change in your business growth.`;
const description2 = `As a full-service digital company, we believe in providing the results. This is all possible due to our competent team with years of professional experience. This has helped us to grow our customer's list in the previous year.`;

const description3 = `The interdisciplinary action by our experts helps us to focus on developing the tailor-made strategy to innovate the businesses of our clients. This ultimately led to increased productivity as a team and inspired us to do more. Note that frequent testing and optimization is the key part of our process. We target the needs of our customers and come up with a plan to upscale their business in the best way possible.`;

const description4 = `As mentioned above, our expert team consists of expert digital markets, app developers, content writers, and website designers. Every department in our company has played a positive role in collaborating with the customer at every stage of the design, development, and even marketing to keep them updated about the progress.`;

export const aboutFaq1 = [
  "We have worked with different customers belonging to a different niche. We understand the need for our business after a detailed discussion with our clients. After we understand their goals, we start developing an extensive plan to elevate their business sales in record time. We have a solid working methodology that allows us to do frequent testing before we can provide the final results to our clients. We will be offering detailed insights to our clients so that they can be satisfied with the final results. Our expert team tries their best to offer great value to our customers belonging to different industries.",
];

export const aboutFaq2 = [
  "A company is always known for the amount of experience and the creative minds behind the growth of the company. We feel lucky because we have both at our company. Our years of working has enabled us to fulfill the requirements of our clients without any problem. Our team consists of experienced and professional digital marketers, content writers, web designers, web developers, and app developers.",
];

export const aboutFaq3 = [
  "We believe in diversity. You can measure this thing in our team and the number of clients we have entertained in our working span. We feel proud in sharing that we have helped different clients from different industries to elevate their business sales. The diversity has enabled us to accept every challenge with courage.",
  "Below are some of the industries that we have worked with in the past years:",
  "• Wholesale & Retail",
  "• Distributors",
  "• Manufacturers",
  "• Production Units",
  "• Healthcare & Pharmaceuticals",
  "• Education (Schools, Colleges, Universities)",
  "• Construction & Real Estate",
  "• Travel & Tourism",
  "• Restaurant",
  "• Super & Mini Marts",
  "• Sports",
];

const AboutUs = () => {
  const handleButtonClick = () => {
    // Handle button click - you can navigate to a specific page or perform any action
    console.log("See Our Work button clicked");
  };

  return (
    <>
      <MetaData
        metaTitle={"About"}
        metaDescription={
          "Softorithm is a cutting-edge digital agency dedicated to simplifying the digital trajectory for businesses."
        }
      />
      {/* <AnimatePage> */}
      <div className="page_body">
        <div className=" mt-5">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="about_rgt_cont text-center">
                <h1 className="text-center mb-4">
                  Welcome to Pakistan’s Leading <br></br>Full-Service Digital
                  Company{" "}
                </h1>

                <TextSlicer text={description} />

                <h2 className="text-center mt-4">Competency- Key To Success</h2>
                <TextSlicer text={description2} />
                <TextSlicer text={description3} />
                <h2 className="text-center mt-4">Team That Stands Out!</h2>
                <TextSlicer text={description4} />
              </div>
            </div>
          </div>
          {/* <div className="videos_posts">
            <div className="container">
              <div className="row">
                <div className="col-lg-4">
                  <div className="yt_post_feature">
                    <span className="pst_overlay"></span>
                    <div className="pst_meta">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="8"
                          viewBox="0 0 18.049 18.049"
                        >
                          <g transform="translate(-2.25 -2.25)">
                            <path
                              d="M11.274,20.3A9.024,9.024,0,1,1,20.3,11.274,9.024,9.024,0,0,1,11.274,20.3Zm0-16.76a7.735,7.735,0,1,0,7.735,7.735A7.735,7.735,0,0,0,11.274,3.539Z"
                              fill="#fff"
                            />
                            <path
                              d="M20.478,17.544l-3.6-3.6V7.875h1.289v5.53l3.223,3.229Z"
                              transform="translate(-6.245 -2.402)"
                              fill="#fff"
                            />
                          </g>
                        </svg>{" "}
                        a year ago
                      </span>
                      <p className="mb-0">Fitness Freak</p>
                    </div>
                    <Link to="/">
                      <span className="yt_ply_btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15.65"
                          height="18"
                          viewBox="0 0 15.65 18"
                        >
                          <path
                            d="M8.561,23.063a1.73,1.73,0,0,1-.856-.228,1.923,1.923,0,0,1-.952-1.679V6.97a1.923,1.923,0,0,1,.952-1.679,1.718,1.718,0,0,1,1.75.022L21.578,12.57a1.761,1.761,0,0,1,0,2.984L9.453,22.812a1.736,1.736,0,0,1-.892.25Z"
                            transform="translate(-6.754 -5.063)"
                            fill="#fff"
                          />
                        </svg>
                      </span>
                    </Link>
                  </div>
                </div>

                <div className="col-lg-8">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="yt_mini_pst">
                        <img src={yt_pst_img} alt="Youtube Mini Post" />
                        <span className="pst_overlay"></span>
                        <div className="pst_meta">
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="8"
                              viewBox="0 0 18.049 18.049"
                            >
                              <g transform="translate(-2.25 -2.25)">
                                <path
                                  d="M11.274,20.3A9.024,9.024,0,1,1,20.3,11.274,9.024,9.024,0,0,1,11.274,20.3Zm0-16.76a7.735,7.735,0,1,0,7.735,7.735A7.735,7.735,0,0,0,11.274,3.539Z"
                                  fill="#fff"
                                />
                                <path
                                  d="M20.478,17.544l-3.6-3.6V7.875h1.289v5.53l3.223,3.229Z"
                                  transform="translate(-6.245 -2.402)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>{" "}
                            a year ago
                          </span>
                          <p className="mb-0">Don't be ignored</p>
                        </div>
                        <Link to="/">
                          <span className="yt_ply_btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15.65"
                              height="18"
                              viewBox="0 0 15.65 18"
                            >
                              <path
                                d="M8.561,23.063a1.73,1.73,0,0,1-.856-.228,1.923,1.923,0,0,1-.952-1.679V6.97a1.923,1.923,0,0,1,.952-1.679,1.718,1.718,0,0,1,1.75.022L21.578,12.57a1.761,1.761,0,0,1,0,2.984L9.453,22.812a1.736,1.736,0,0,1-.892.25Z"
                                transform="translate(-6.754 -5.063)"
                                fill="#fff"
                              />
                            </svg>
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="yt_mini_pst">
                        <img src={yt_pst_img} alt="Youtube Mini Post" />
                        <span className="pst_overlay"></span>
                        <div className="pst_meta">
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="8"
                              viewBox="0 0 18.049 18.049"
                            >
                              <g transform="translate(-2.25 -2.25)">
                                <path
                                  d="M11.274,20.3A9.024,9.024,0,1,1,20.3,11.274,9.024,9.024,0,0,1,11.274,20.3Zm0-16.76a7.735,7.735,0,1,0,7.735,7.735A7.735,7.735,0,0,0,11.274,3.539Z"
                                  fill="#fff"
                                />
                                <path
                                  d="M20.478,17.544l-3.6-3.6V7.875h1.289v5.53l3.223,3.229Z"
                                  transform="translate(-6.245 -2.402)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>{" "}
                            a year ago
                          </span>
                          <p className="mb-0">Don't be ignored</p>
                        </div>
                        <Link to="/">
                          <span className="yt_ply_btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15.65"
                              height="18"
                              viewBox="0 0 15.65 18"
                            >
                              <path
                                d="M8.561,23.063a1.73,1.73,0,0,1-.856-.228,1.923,1.923,0,0,1-.952-1.679V6.97a1.923,1.923,0,0,1,.952-1.679,1.718,1.718,0,0,1,1.75.022L21.578,12.57a1.761,1.761,0,0,1,0,2.984L9.453,22.812a1.736,1.736,0,0,1-.892.25Z"
                                transform="translate(-6.754 -5.063)"
                                fill="#fff"
                              />
                            </svg>
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="yt_mini_pst">
                        <img src={yt_pst_img} alt="Youtube Mini Post" />
                        <span className="pst_overlay"></span>
                        <div className="pst_meta">
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="8"
                              viewBox="0 0 18.049 18.049"
                            >
                              <g transform="translate(-2.25 -2.25)">
                                <path
                                  d="M11.274,20.3A9.024,9.024,0,1,1,20.3,11.274,9.024,9.024,0,0,1,11.274,20.3Zm0-16.76a7.735,7.735,0,1,0,7.735,7.735A7.735,7.735,0,0,0,11.274,3.539Z"
                                  fill="#fff"
                                />
                                <path
                                  d="M20.478,17.544l-3.6-3.6V7.875h1.289v5.53l3.223,3.229Z"
                                  transform="translate(-6.245 -2.402)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>{" "}
                            a year ago
                          </span>
                          <p className="mb-0">Don't be ignored</p>
                        </div>
                        <Link to="/">
                          <span className="yt_ply_btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15.65"
                              height="18"
                              viewBox="0 0 15.65 18"
                            >
                              <path
                                d="M8.561,23.063a1.73,1.73,0,0,1-.856-.228,1.923,1.923,0,0,1-.952-1.679V6.97a1.923,1.923,0,0,1,.952-1.679,1.718,1.718,0,0,1,1.75.022L21.578,12.57a1.761,1.761,0,0,1,0,2.984L9.453,22.812a1.736,1.736,0,0,1-.892.25Z"
                                transform="translate(-6.754 -5.063)"
                                fill="#fff"
                              />
                            </svg>
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="yt_mini_pst">
                        <img src={yt_pst_img} alt="Youtube Mini Post" />
                        <span className="pst_overlay"></span>
                        <div className="pst_meta">
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="8"
                              viewBox="0 0 18.049 18.049"
                            >
                              <g transform="translate(-2.25 -2.25)">
                                <path
                                  d="M11.274,20.3A9.024,9.024,0,1,1,20.3,11.274,9.024,9.024,0,0,1,11.274,20.3Zm0-16.76a7.735,7.735,0,1,0,7.735,7.735A7.735,7.735,0,0,0,11.274,3.539Z"
                                  fill="#fff"
                                />
                                <path
                                  d="M20.478,17.544l-3.6-3.6V7.875h1.289v5.53l3.223,3.229Z"
                                  transform="translate(-6.245 -2.402)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>{" "}
                            a year ago
                          </span>
                          <p className="mb-0">Don't be ignored</p>
                        </div>
                        <Link to="/">
                          <span className="yt_ply_btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15.65"
                              height="18"
                              viewBox="0 0 15.65 18"
                            >
                              <path
                                d="M8.561,23.063a1.73,1.73,0,0,1-.856-.228,1.923,1.923,0,0,1-.952-1.679V6.97a1.923,1.923,0,0,1,.952-1.679,1.718,1.718,0,0,1,1.75.022L21.578,12.57a1.761,1.761,0,0,1,0,2.984L9.453,22.812a1.736,1.736,0,0,1-.892.25Z"
                                transform="translate(-6.754 -5.063)"
                                fill="#fff"
                              />
                            </svg>
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="yt_mini_pst">
                        <img src={yt_pst_img} alt="Youtube Mini Post" />
                        <span className="pst_overlay"></span>
                        <div className="pst_meta">
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="8"
                              viewBox="0 0 18.049 18.049"
                            >
                              <g transform="translate(-2.25 -2.25)">
                                <path
                                  d="M11.274,20.3A9.024,9.024,0,1,1,20.3,11.274,9.024,9.024,0,0,1,11.274,20.3Zm0-16.76a7.735,7.735,0,1,0,7.735,7.735A7.735,7.735,0,0,0,11.274,3.539Z"
                                  fill="#fff"
                                />
                                <path
                                  d="M20.478,17.544l-3.6-3.6V7.875h1.289v5.53l3.223,3.229Z"
                                  transform="translate(-6.245 -2.402)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>{" "}
                            a year ago
                          </span>
                          <p className="mb-0">Don't be ignored</p>
                        </div>
                        <Link to="/">
                          <span className="yt_ply_btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15.65"
                              height="18"
                              viewBox="0 0 15.65 18"
                            >
                              <path
                                d="M8.561,23.063a1.73,1.73,0,0,1-.856-.228,1.923,1.923,0,0,1-.952-1.679V6.97a1.923,1.923,0,0,1,.952-1.679,1.718,1.718,0,0,1,1.75.022L21.578,12.57a1.761,1.761,0,0,1,0,2.984L9.453,22.812a1.736,1.736,0,0,1-.892.25Z"
                                transform="translate(-6.754 -5.063)"
                                fill="#fff"
                              />
                            </svg>
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="yt_mini_pst">
                        <img src={yt_pst_img} alt="Youtube Mini Post" />
                        <span className="pst_overlay"></span>
                        <div className="pst_meta">
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="8"
                              viewBox="0 0 18.049 18.049"
                            >
                              <g transform="translate(-2.25 -2.25)">
                                <path
                                  d="M11.274,20.3A9.024,9.024,0,1,1,20.3,11.274,9.024,9.024,0,0,1,11.274,20.3Zm0-16.76a7.735,7.735,0,1,0,7.735,7.735A7.735,7.735,0,0,0,11.274,3.539Z"
                                  fill="#fff"
                                />
                                <path
                                  d="M20.478,17.544l-3.6-3.6V7.875h1.289v5.53l3.223,3.229Z"
                                  transform="translate(-6.245 -2.402)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>{" "}
                            a year ago
                          </span>
                          <p className="mb-0">Don't be ignored</p>
                        </div>
                        <Link to="/">
                          <span className="yt_ply_btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15.65"
                              height="18"
                              viewBox="0 0 15.65 18"
                            >
                              <path
                                d="M8.561,23.063a1.73,1.73,0,0,1-.856-.228,1.923,1.923,0,0,1-.952-1.679V6.97a1.923,1.923,0,0,1,.952-1.679,1.718,1.718,0,0,1,1.75.022L21.578,12.57a1.761,1.761,0,0,1,0,2.984L9.453,22.812a1.736,1.736,0,0,1-.892.25Z"
                                transform="translate(-6.754 -5.063)"
                                fill="#fff"
                              />
                            </svg>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* Section 7 - CTA Section */}
          <section className="erp_cta_section">
            <Container>
              <Row className="align-items-center">
                <Col lg={8} md={7} sm={12} className="mb-3 mb-md-0">
                  <p className="erp_cta_text text-md-start text-center ">
                    Contact us to find out what we can do for your business.
                  </p>
                </Col>
                <Col
                  lg={4}
                  md={5}
                  sm={12}
                  className="text-center text-md-start"
                >
                  <button
                    type="button"
                    className="erp_cta_btn"
                    onClick={handleButtonClick}
                  >
                    Call Us Today!
                  </button>
                </Col>
              </Row>
            </Container>
          </section>

          <div className="container mt-5">
            <div
              className="faq_section py-3"
              style={{ backgroundColor: "var(--body-bg-color, #f8f9fa)" }}
            >
              <Container>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="faq_header text-center mb-5">
                      <h2 className="mb-3">Frequently Asked Questions</h2>
                    </div>
                    <FAQAccordion
                      faqData={[
                        {
                          question:
                            "How to start working with SoftoRithm Technologies?",
                          points: aboutFaq1,
                        },
                        {
                          question:
                            "How many years of industry experience do you have?",
                          points: aboutFaq2,
                        },
                        {
                          question:
                            "What types of industries do SoftoRithm Technologies support?",
                          points: aboutFaq3,
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
      {/* </AnimatePage> */}
    </>
  );
};
export default AboutUs;
